export default __webpack_public_path__ + "static/media/sss.7661f24b.svg";